import { useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { useSearchParams } from './useSearchParams';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { getAbsoluteUrlWithParams } from '../utils';
import { dashboardPagePath } from '../components/navigation/paths';

export const useForceLogin = (): void => {
    const { isAuthenticated, isLoading, login } = useOidcAuthentication();
    const [searchParams, setSearchParams] = useSearchParams();
    const { i18n } = useTranslation();
    const locale = i18n.languages[0];

    useEffect(() => {
        if (isLoading) {
            return;
        }

        // Force login when user switches between contracts under same account
        if (searchParams.get('forceLogin') === 'true') {
            searchParams.delete('forceLogin');
            setSearchParams(searchParams);

            if (!isAuthenticated) {
                login({
                    redirect_uri: getAbsoluteUrlWithParams(dashboardPagePath()),
                    redirectTarget: 'self',
                    redirectMethod: 'assign',
                    ui_locales: locale,
                });
            }
        }
    }, [isAuthenticated, isLoading]);
};
